<template>
  <div>
    <!-- Intro -->
    <div>
      <div>
        <div class="py-xxl has-text-white has-text-centered">
          <h1 class="is-size-4">Billing & Payments</h1>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="section">
      <div class="container">
        <div class="has-background-white pa-xxl rounded-xl">
          Billing & Payments
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  computed: {
    ...mapGetters([])
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>
